<div class="promotion-code-child-component">
  <h5>KYC Verification Setting</h5>
  <div class="promotion-code-child-component-content">
    <div class="row">
      <div class="col-4">
          <div class="selection-button" 
                [class.active]="selectedOption === 'manual'" 
                (click)="onSelect('manual')">
              <div class="col-10">
                  <p>Manual</p>
                  <p>Manually verify members by setting requirements.</p>
              </div>
              <div class="col-2">
                  <div class="selection-button-dot"></div>
              </div>
          </div>
      </div>

      <div class="col-4">
          <div class="selection-button" 
                [class.active]="selectedOption === 'kyc-status'" 
                (click)="onSelect('kyc-status')">
              <div class="col-10">
                  <p>KYC Status</p>
                  <p>Automatically verify members based on their KYC approval status.</p>
              </div>
              <div class="col-2">
                  <div class="selection-button-dot"></div>
              </div>
          </div>
      </div>

      <div class="col-4">
          <div class="selection-button" 
                [class.active]="selectedOption === 'none'" 
                (click)="onSelect('none')">
              <div class="col-10">
                  <p>None</p>
              </div>
              <div class="col-2">
                  <div class="selection-button-dot"></div>
              </div>
          </div>
      </div>
    </div>

    <div class="kyc-setting-row" *ngIf="selectedOption === 'manual' || selectedOption === 'kyc-status'">
      <ng-container *ngIf="selectedOption === 'manual'">
          <form [formGroup]="form">
            <div class="row">
                <div class="col-4 mb-4">
                  <span class="kt-font-bold">KYC Verified Setting <span class="text-danger">*</span></span>
                    <kt-dropdown-wo-lazyload
                      [form]= 'form'
                      [dropdownList]= 'dropdown.kycOptions'
                      [dropdownSettings]= 'kycOptionDropdownSettings'
                      [formName]="'kyc_option'"
                      [selectionAttributes]="'id'"
                      [selectedItems]= 'kycOptionSelectedItem'>
                    </kt-dropdown-wo-lazyload>  
                </div>
            </div>
          </form>
        </ng-container>

        <ng-container *ngIf="selectedOption === 'kyc-status'">
            <form [formGroup]="form">
              <div class="row">
                  <div class="col-4 mb-4">
                      <span class="kt-font-bold">KYC Status <span class="text-danger">*</span></span>
                        <kt-dropdown-wo-lazyload
                          [form] = 'form'
                          [dropdownList] = 'dropdown.kycStatuses'
                          [dropdownSettings] = 'kycStatusDropdownSettings'
                          [formName] = "'kyc_status'"
                          [selectionAttributes] = "'id'"
                          [selectedItems] ='kycStatusSelectedItem'>
                        </kt-dropdown-wo-lazyload>
                  </div>
              </div>
            </form>
        </ng-container>
    </div>
  </div>
</div>